import React, { Component } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import {fetchControl,updateControl,updateControlSettings} from '../../actions/control'
import {fetchQuestionPolls, fetchSetPolls} from '../../actions/polls'
import {resetControl} from '../../utils/resetControl'
import LiveViewScreenNavigationBar from '../../components/liveView/LiveViewScreenNavigationBar'
import LiveViewEmptyState from '../../components/liveView/LiveViewEmptyState'
import LiveViewToolBar from '../../components/liveView/LiveViewToolBar'
import LiveViewReviewScreenControls from '../../components/liveView/LiveViewReviewScreenControls'
import LiveViewCardAssignmentView from '../../components/liveView/LiveViewCardAssignmentView'
import {playPoll} from '../../utils/playItem'
import LiveViewMain from '../../components/liveView/LiveViewMain' 
import LiveViewPerfectScoreCelebration from '../../components/liveView/LiveViewPerfectScoreCelebration' 
import {calculateNPLayout} from '../../utils/calculateNPLayout' 
import {getPollForControl,getSetPollForControl} from '../../utils/getPollForControl'
import {buildQuestionsAndPollsList} from '../../utils/buildQuestionsAndPollsList'
import {getLiveViewSettings} from '../../utils/getLiveViewSettings'
import {isSurvey} from '../../utils/isSurvey'
import {calculatePercentCorrect} from '../../utils/calculatePercentCorrect'


const NAV_FADEOUT_TIME=3000//time in ms
const PERFECT_SCORE_DISPLAY_TIME=6000//time in ms

const perfectScoreIsDisplayed = (props) => { 	
	const liveViewSettings=getLiveViewSettings()
	if(props.control.revealAnswer &&
		(props.control.showGraph || liveViewSettings.alwaysShowGraph)
		&& !props.control.scanning
	) {
		let poll
		if(props.control && (props.control.setPoll || props.control.currentPoll)){		 		
			 poll=getPollForControl(props.control)
		}
		if(poll && poll.hasResponses){
			const correctPercent=calculatePercentCorrect(poll)
			if(correctPercent===100){
				return true
			}else return false
		}else return false

	}
	else return false
}


 
class LiveViewContainer extends Component {

	constructor(){
		super()
		this.launchFullscreen=this.launchFullscreen.bind(this)
		this.exitFullscreen=this.exitFullscreen.bind(this)
		this.hideNavBar=this.hideNavBar.bind(this)
		this.showNavBar=this.showNavBar.bind(this)
		this.stopLiveView=this.stopLiveView.bind(this)
		this.playQuestionInSet=this.playQuestionInSet.bind(this)
		this.refreshControl=this.refreshControl.bind(this)
		this.handlePlayPoll=this.handlePlayPoll.bind(this)
		this.updateWindowDimensions=this.updateWindowDimensions.bind(this)
		this.recalculateLayout=this.recalculateLayout.bind(this)
		this.showCardAssignmentView=this.showCardAssignmentView.bind(this)
		this.clickToCloseCardAssignmentView=this.clickToCloseCardAssignmentView.bind(this)
		this.handleFullScreenChange=this.handleFullScreenChange.bind(this)
		this.handleMinimiseLiveView=this.handleMinimiseLiveView.bind(this)
		this.handleClick=this.handleClick.bind(this)
		this.toggleShowCorrect=this.toggleShowCorrect.bind(this)
		this.toggleShowGraph=this.toggleShowGraph.bind(this)
		this.handleKeyDown=this.handleKeyDown.bind(this)
		this.handleDoubleClick=this.handleDoubleClick.bind(this)
		this.showPerfectScoreCelebration=this.showPerfectScoreCelebration.bind(this)
		this.hidePerfectScoreCelebration=this.hidePerfectScoreCelebration.bind(this)
		this.toggleManualShowIndividualStudentResponses=this.toggleManualShowIndividualStudentResponses.bind(this)


		this.hideNavBar = debounce(this.hideNavBar,NAV_FADEOUT_TIME)
		
		this.state=({
			windowWidth: 0,
			windowHeight: 0,
			fullScreen:false,
			dimensions:null,
			showNavBar:false,
			cardAssigmentViewVisible:false,
			resizing:false,
			isEmptyState:null,
			layout:{},
			manualShowIndividualStudentResponses:false,
			studentsAndGuestsCount:0,
			showPerfectScoreCelebration:false
		})
		this.questionsAndPollsList=null
		this.timeout=null
	 
	}

	UNSAFE_componentWillMount() {
		this.props.fetchControl()
	}

	componentDidMount() {
  		this.updateWindowDimensions()
  		window.addEventListener('resize', this.updateWindowDimensions)
  		window.addEventListener('click', this.handleClick)
  		document.addEventListener('webkitfullscreenchange', this.handleFullScreenChange)
  		document.addEventListener('fullscreenchange', this.handleFullScreenChange)	
		document.addEventListener('mozfullscreenchange', this.handleFullScreenChange)
		document.addEventListener('MSFullscreenChange', this.handleFullScreenChange)

  		
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions)
		window.removeEventListener('click', this.handleClick)
		document.removeEventListener('webkitfullscreenchange', this.handleFullScreenChange)
  		document.removeEventListener('fullscreenchange', this.handleFullScreenChange)	
		document.removeEventListener('mozfullscreenchange', this.handleFullScreenChange)
		document.removeEventListener('MSFullscreenChange', this.handleFullScreenChange)
		this.hideNavBar.cancel()
	}



	UNSAFE_componentWillReceiveProps(nextProps) {

		if(nextProps.control && nextProps.currentSection&& (nextProps.control.setPoll || nextProps.control.currentPoll)){
			this.setState({isEmptyState:false})
			this.recalculateLayout(nextProps.control,nextProps.currentSection)
			if(nextProps.control.setPoll){
				const setPoll=getSetPollForControl(nextProps.control)
				if(setPoll && setPoll.snapshot){
					this.questionsAndPollsList=buildQuestionsAndPollsList(setPoll)
				}
			}else this.questionsAndPollsList=null
		}else{
			this.setState({isEmptyState:true,cardAssigmentViewVisible:false})
		}

		if(!this.props.visibile && nextProps.visible){
			document.body.style.overflowY = 'hidden'
			window.addEventListener('keydown', this.handleKeyDown)
		}else if(this.props.visible && !nextProps.visible){
			document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
			document.body.style.overflowY='overlay' 
			window.removeEventListener('keydown', this.handleKeyDown)


		}
		if(nextProps.visible && !this.props.visible){
			if(typeof window.ga === 'function'){
  				window.ga('set', 'page',  '/nowplaying')
				window.ga('send', 'pageview')
  			}
		}

		if((nextProps.control.setPollPoll !==this.props.control.setPollPoll)||(nextProps.control.currentPoll !==this.props.control.currentPoll)){
			this.setState({manualShowIndividualStudentResponses:false})
		}
		if(perfectScoreIsDisplayed(nextProps) && !perfectScoreIsDisplayed(this.props)){
			this.showPerfectScoreCelebration()
		}else if(!perfectScoreIsDisplayed(nextProps) && this.state.showPerfectScoreCelebration){
			this.hidePerfectScoreCelebration()

		}

	}

	showPerfectScoreCelebration(){
		this.setState({showPerfectScoreCelebration:true})
		this.timeout=setTimeout(() => {
	            this.setState({
	            showPerfectScoreCelebration:false
	          })
	        }, PERFECT_SCORE_DISPLAY_TIME)
	}

	hidePerfectScoreCelebration(){
		this.setState({showPerfectScoreCelebration:false})	
		if (this.timeout) {
			  clearTimeout(this.timeout)
			  this.timeout = null
		}
	}




	toggleManualShowIndividualStudentResponses(){
		this.setState({manualShowIndividualStudentResponses:!this.state.manualShowIndividualStudentResponses})
	}



	handleClick(){
		this.showNavBar()
	}

	updateWindowDimensions() {  
	  const layout=calculateNPLayout(window.innerWidth,window.innerHeight,this.state.studentsAndGuestsCount, this.state.fullScreen)
	 	this.setState({layout:layout,windowWidth: window.innerWidth, windowHeight: window.innerHeight,resizing:true})
	   setTimeout(function(){
	        this.setState({resizing:false})
	    }.bind(this), 800) //Use this to prevent onMouseMove when going to full screen
	}

 
	handleKeyDown(e){
		if(!this.state.fullScreen && e.keyCode === 27){//escape key
			this.props.minimiseLiveView()
		}
	}

 
	recalculateLayout(control,section){ //Temp
		const poll=getPollForControl(control)
		let studentCount=0
		let guestCount=0
		if(this.props.currentSection){
			const students=filter(this.props.currentSection.students,{archived:false})
			studentCount=students.length
			if(poll){
				guestCount=poll.unassignedResponseCount || 0
			}
		}

		const studentsAndGuestsCount=studentCount+guestCount
		if(studentsAndGuestsCount!==this.state.studentsAndGuestsCount){
			//recalculate layout
			const layout=calculateNPLayout(window.innerWidth,window.innerHeight,studentsAndGuestsCount, this.state.fullScreen)
	 		this.setState({layout:layout,studentsAndGuestsCount:studentsAndGuestsCount})


		}
	}


	refreshControl(){
		this.props.fetchControl()
	}


	handleFullScreenChange(){
		this.setState({fullScreen:!this.state.fullScreen},()=>{this.updateWindowDimensions()})
		
	}

	launchFullscreen() {
		const element =  this.refs.ForFullScreen
		//find which method the browser recognises
		if(element.requestFullscreen) {
			element.requestFullscreen()
		} else if(element.mozRequestFullScreen) {
			element.mozRequestFullScreen()
		} else if(element.webkitRequestFullscreen) {
			element.webkitRequestFullscreen()
		} else if(element.msRequestFullscreen) {
			element.msRequestFullscreen()
		}
		this.setState({showNavBar:false})


	}

	exitFullscreen() {

		//find which method the browser recognises
		if(document.fullscreen){
			if(document.exitFullscreen) {
			document.exitFullscreen()
		} else if(document.mozExitFullScreen) {
			document.mozExitFullScreen()
		} else if(document.webkitExitFullscreen) {
			document.webkitExitFullscreen()
		} else if(document.msExitFullscreen) {
			document.msExitFullscreen()
		}
		
		}
		
	}

	stopLiveView(){
		this.props.resetControl()
		if(this.state.fullScreen){
			this.exitFullscreen()
		}

		this.props.minimiseLiveView()
	}

	handleMinimiseLiveView(){
		if(this.state.fullScreen){
			this.exitFullscreen()
		}
		this.props.minimiseLiveView()
	}

	toggleShowCorrect(){
		const control=this.props.control
		const nowDate = new Date()	
		const newControl={
			...control,
			controlled:nowDate,
			revealAnswer:!control.revealAnswer,
		}
		return this.props.updateControlSettings(newControl).then((response)=>{
			return response
		})
	}


	toggleShowGraph(){
		const control=this.props.control
		const nowDate = new Date()	
		const newControl={
			...control,
			controlled:nowDate,
			showGraph:!control.showGraph,
		}
		return this.props.updateControlSettings(newControl).then((response)=>{
			return response
		})
	}



	playQuestionInSet(questionAndPoll){
		let control=this.props.control
		const snapshot=questionAndPoll.questionSnapshot		
		const nowDate = new Date()
		let setPollPollId
		if(questionAndPoll.poll){
			setPollPollId=questionAndPoll.poll.id
		}else{
			// setPollPollId=generateRandomId()
			setPollPollId=questionAndPoll.questionSnapshot.questionId

			// questionAndPoll.poll.id
		}
		
		control={
			...control,
			controlled:nowDate,
			scanning:false,
			setPollPoll:setPollPollId,
			snapshot:snapshot,
			showGraph:false,
			revealAnswer:false,
		}
		this.props.updateControl(control)
	}



	hideNavBar(){
		this.setState({showNavBar:false}) 
	}

	
	showNavBar(){ 
		if(this.state.resizing===false){  //dont show navbar is mouse move is due to launching fullscreen
			this.setState({showNavBar:true})
			this.hideNavBar()
		}
	}

	

	handlePlayPoll(poll,item){
		this.props.playPoll(poll,item)
	}
 
	showCardAssignmentView(){
		this.setState({cardAssigmentViewVisible:true})
		document.addEventListener('click', this.clickToCloseCardAssignmentView)
	}
	clickToCloseCardAssignmentView(){
		this.setState({cardAssigmentViewVisible:false})
		document.removeEventListener('click', this.clickToCloseCardAssignmentView)
	}

	handleDoubleClick(){
		if(this.state.fullScreen){
			this.exitFullscreen()
		}else{
			this.launchFullscreen()	
		}
	}



	render() {
		const {control}=this.props
		const {isEmptyState, layout,cardAssigmentViewVisible}=this.state
		let isScan=false
		if(control){
			 isScan=control.scanning
		}



 		let currentQuestionIndex=0

		if(this.questionsAndPollsList){
			currentQuestionIndex=this.questionsAndPollsList.findIndex(questionAndPoll => {
				if(questionAndPoll && this.props.control){
					if(questionAndPoll.questionSnapshot && this.props.control.snapshot){
						return questionAndPoll.questionSnapshot.questionId === this.props.control.snapshot.questionId
					}
				}return null
			})
		}


		const displayStyle = this.props.visible 
		    ? {
		    	'visibility':'visible',
		    	'opacity':'1',

		      }
		    : {
		    	'visibility':'hidden',
		    	'opacity':'0',
		      }

		   
		 	let poll
		 	let setPoll
		 	if(control && (control.setPoll || control.currentPoll)){		 		
		 		poll=getPollForControl(control)
		}
		if(control.setPoll){
			setPoll=getSetPollForControl(control)
		}

		let isReviewScreen=false
		if(!isScan && poll && poll.hasResponses){
		  isReviewScreen=true
		 } 
		  const liveViewSettings=getLiveViewSettings()
		  let controlsAreVisible=this.state.showNavBar
		  if(liveViewSettings.alwaysShowControls){
		  	controlsAreVisible=true
		  }

		let questionIsSurvey=false
		if(poll){
			questionIsSurvey=isSurvey(poll.snapshot)
		}

		let showGraph=control.showGraph
		if(liveViewSettings.alwaysShowGraph){
			showGraph=true
		}






		return (				
			<div style={displayStyle} className='liveViewContainer' onMouseMove={() =>{this.showNavBar()}} ref='ForFullScreen' >				



				{!this.state.fullScreen && 
					<LiveViewToolBar 
						toolBarHeight={layout.defaultHeightLiveViewToolbar} 				
						isEmptyState={isEmptyState}
						section={this.props.currentSection}
						minimiseLiveView={this.handleMinimiseLiveView}
						stopLiveView={this.stopLiveView}
						liveViewEmpty={isEmptyState}
						isVisible={this.state.showNavBar}					
					/>
				}
					
											
				{cardAssigmentViewVisible &&
					<LiveViewCardAssignmentView
						section={this.props.currentSection}
						sortOrder={liveViewSettings.studentSortOrder}
					/>
				} 

				{isEmptyState===true &&
					<LiveViewEmptyState									
						refreshControl={this.refreshControl}
						control={control}
					/>
				}  

				{isEmptyState===false &&				
					<LiveViewScreenNavigationBar
						questionsAndPollsList={this.questionsAndPollsList}
						currentQuestionIndex={currentQuestionIndex}
						queue={this.props.queue}
						section={this.props.currentSection}
						isVisible={this.state.showNavBar}
						fullScreen={this.state.fullScreen}
						launchFullscreen={this.launchFullscreen}
						exitFullscreen={this.exitFullscreen}
						playQuestionInSet={this.playQuestionInSet}
						playPoll={this.handlePlayPoll}
						showCardAssignmentView={this.showCardAssignmentView}
						currentSetPoll={setPoll}

					 />
				}

				{isEmptyState===false &&
					<LiveViewReviewScreenControls 
						manualShowIndividualStudentResponses={this.state.manualShowIndividualStudentResponses}
						showIndividualStudentResponses={liveViewSettings.showIndividualResponses}
						alwaysShowGraph={liveViewSettings.alwaysShowGraph}
						studentListVisible={liveViewSettings.studentListVisible}
						poll={poll}
						layout={layout}
						isVisible={controlsAreVisible}
						showGraph={showGraph} 
						questionIsSurvey={questionIsSurvey}
						showCorrect={control.revealAnswer} 
						toggleShowCorrect={this.toggleShowCorrect}
						toggleShowGraph={this.toggleShowGraph}
						fullScreen={this.state.fullScreen}
						toggleShowIndividualStudentResponses={this.toggleManualShowIndividualStudentResponses}						
					/>				
				}
 
				{isEmptyState===false &&
					<LiveViewMain
						showIndividualStudentResponses={liveViewSettings.showIndividualResponses}
						manualShowIndividualStudentResponses={this.state.manualShowIndividualStudentResponses}
						handleDoubleClick={this.handleDoubleClick}
						liveViewSettings={liveViewSettings}
						layout={layout} 
						scaleTest={layout.scanSlideScale}
						isScan={isScan}
						isSurvey={questionIsSurvey}
						isReviewScreen={isReviewScreen} 
						showGraph={showGraph} 
						showCorrect={control.revealAnswer} 
						section={this.props.currentSection} 
						// currentPoll={this.props.currentPoll}
						// currentSetPoll={this.props.currentSetPoll}
						// currentSetPollPoll={this.props.currentSetPollPoll}
						currentPollId={this.props.currentPollId}
						currentSetPollId={this.props.currentSetPollId}
						currentSetPollPollId={this.props.currentSetPollPollId}
						snapshot={control.snapshot}	
						poll={poll}						
					/>
				}
				
				<LiveViewPerfectScoreCelebration
					showPerfectScoreCelebration={this.state.showPerfectScoreCelebration}
					windowWidth={this.state.windowWidth}
					windowHeight={this.state.windowHeight}
					totalDisplayTime={PERFECT_SCORE_DISPLAY_TIME}
					hidePerfectScoreCelebration={this.hidePerfectScoreCelebration}
				/>
				
			</div>	
								
		)
	}
}


function mapStateToProps(state) {
	const control=state.control
	let currentSection=null
	let currentPollId= null
	let currentSetPollId=null
	let currentSetPollPollId = null

	let queue=[]

	if(state.control){
		currentSetPollId=control.setPoll
		currentSetPollPollId=control.setPollPoll
		currentPollId=control.currentPoll
		currentSection=find(state.sections, {'id':state.control.section})
		//currentPoll= find(state.queueQuestionPolls, {'id':control.currentPoll}) || find(state.historyQuestionPolls, {'id':control.currentPoll}) 
		const currentSectionQueueQuestionPolls=filter(state.queueQuestionPolls,{'section':state.control.section})
		const currentSectionQueueSetPolls=filter(state.queueSetPolls,{'section':state.control.section})
 		queue=sortBy(currentSectionQueueQuestionPolls.concat(currentSectionQueueSetPolls), 'planned')
 	
 		if(queue[0]){
 		if(queue[0].id ===control.currentPoll || queue[0].id ===control.setPoll){
 			queue.splice(0, 1) //remove from upnext queue if currently being played
 		}}

	}


	return {
		control:control,
		currentSection:currentSection,
		queue:queue,
		currentPollId:currentPollId,
		currentSetPollId:currentSetPollId,
		currentSetPollPollId:currentSetPollPollId


	}
}




export default connect(
	mapStateToProps,
	{ fetchControl,
		updateControl,
		fetchQuestionPolls,
		fetchSetPolls,
		playPoll,
		resetControl,
		updateControlSettings
	}
)(LiveViewContainer)




// WEBPACK FOOTER //
// ./src/containers/liveView/LiveViewContainer.js